module.exports = __webpack_public_path__ + "static/media/1-5-1.4df810f4.png";